// extracted by mini-css-extract-plugin
module.exports = {"sponsor":"sponsor-module--sponsor--2J1tF","level":"sponsor-module--level--jYlrc"};